<template>
  <Dropdown
    trigger="click"
    class="rp-insert-pause-dropdown"
    transfer-class-name="rp-insert-pause-transfer"
    :placement="placement"
    @on-click="onSelectPreset"
    @on-visible-change="onVisibleChange"
  >
    <Button
      type="default"
      size="small"
      class="rp-insert-pause-btn"
      :class="{ 'rp-insert-pause-btn--footer': buttonStyle === 'footer' }"
    >+ 插入停顿</Button>
    <DropdownMenu slot="list" class="rp-insert-pause-menu">
      <DropdownItem
        v-for="sec in pausePresets"
        :key="sec"
        :name="String(sec)"
        class="rp-insert-pause-item"
      >
        停顿{{ sec }}秒
      </DropdownItem>
      <li class="rp-insert-pause-custom-wrap" @click.stop>
        <div class="rp-insert-pause-custom">
          <InputNumber
            v-model="pauseCustomSec"
            :min="0"
            :step="0.1"
            :precision="1"
            class="rp-insert-pause-custom__input"
          />
          <span class="rp-insert-pause-custom__unit">秒</span>
        </div>
        <Button type="primary" size="small" long class="rp-insert-pause-confirm" @click="confirmCustomPause">
          确认
        </Button>
      </li>
    </DropdownMenu>
  </Dropdown>
</template>

<script>
import { formatPauseTag } from '../../utils/callControlHelpers'

export default {
  name: 'LlmInsertPauseDropdown',
  props: {
    placement: {
      type: String,
      default: 'top-end',
    },
    buttonStyle: {
      type: String,
      default: 'footer',
    },
  },
  data() {
    return {
      pausePresets: [0.5, 1, 2],
      pauseCustomSec: 0,
    }
  },
  methods: {
    onVisibleChange(visible) {
      if (visible) this.pauseCustomSec = 0
    },
    onSelectPreset(name) {
      const sec = Number(name)
      if (!Number.isFinite(sec)) return
      const tag = formatPauseTag(sec)
      if (!tag) return
      this.$emit('insert', tag)
    },
    confirmCustomPause() {
      const tag = formatPauseTag(this.pauseCustomSec)
      if (!tag) {
        this.$Message.warning('请输入大于 0 的停顿时长')
        return
      }
      this.$emit('insert', tag)
    },
  },
}
</script>

<style lang="scss" scoped>
.rp-insert-pause-dropdown {
  flex-shrink: 0;
}

.rp-insert-pause-btn {
  height: 28px !important;
  padding: 0 12px !important;
  border: 1px solid #91d5ff !important;
  border-radius: 4px !important;
  background: #e6f7ff !important;
  color: #1890ff !important;
  font-size: 14px !important;
  line-height: 26px !important;
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    background 0.2s ease,
    color 0.2s ease,
    box-shadow 0.2s ease;

  &:hover,
  &:focus {
    border-color: #1890ff !important;
    color: #0050b3 !important;
    background: #bae7ff !important;
    box-shadow: 0 1px 4px rgba(24, 144, 255, 0.18) !important;
  }

  &--footer {
    height: auto !important;
    min-height: 24px;
    padding: 4px 10px !important;
    border: none !important;
    border-radius: 4px !important;
    background: transparent !important;
    color: #5668f0 !important;
    font-size: 14px !important;
    line-height: 1.4 !important;
    box-shadow: none !important;

    &:hover,
    &:focus {
      border: none !important;
      background: #eef0fe !important;
      color: #404eec !important;
      box-shadow: none !important;
    }

    &:active {
      background: #e0e4fc !important;
      color: #3648d9 !important;
    }
  }
}
</style>

<style lang="scss">
.rp-insert-pause-transfer.ivu-select-dropdown {
  min-width: 160px;
  padding: 4px 0;
}
.rp-insert-pause-transfer .ivu-dropdown-item.rp-insert-pause-item {
  padding: 10px 14px !important;
  line-height: normal !important;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: #f5f7ff !important;
  }
}
.rp-insert-pause-custom-wrap {
  list-style: none;
  margin: 0;
  padding: 4px 10px 8px;
}
.rp-insert-pause-custom {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
}
.rp-insert-pause-custom__input {
  flex: 1;
  min-width: 0;
}
.rp-insert-pause-custom__input .ivu-input-number-input {
  border: none !important;
  box-shadow: none !important;
  height: 32px;
}
.rp-insert-pause-custom__input .ivu-input-number-handler-wrap {
  display: none;
}
.rp-insert-pause-custom__unit {
  padding: 0 10px;
  font-size: 13px;
  color: #8c8c8c;
  background: #fafafa;
  height: 32px;
  line-height: 32px;
  border-left: 1px solid #dcdfe6;
  flex-shrink: 0;
}
.rp-insert-pause-confirm {
  display: block;
  width: 100%;
}

.rp-insert-pause-btn.rp-insert-pause-btn--footer.ivu-btn-default:hover,
.rp-insert-pause-btn.rp-insert-pause-btn--footer.ivu-btn-default:focus {
  border-color: transparent !important;
  background: #eef0fe !important;
  color: #404eec !important;
}

.rp-insert-pause-btn.rp-insert-pause-btn--footer.ivu-btn-default:active {
  background: #e0e4fc !important;
  color: #3648d9 !important;
}
</style>
